// =============================================================================
// FEATURE FLAGS — Single source of truth for platform toggles
// Controlled via env vars in Railway (NEXT_PUBLIC_ prefix for client-side)
// =============================================================================

export const ENABLE_KALSHI = process.env.NEXT_PUBLIC_ENABLE_KALSHI !== 'false';
// Predict.fun (BSC/USDT) sigue oculto hasta el rollout de producción — opt-in
// como Hyperliquid (default OFF). Se prende con NEXT_PUBLIC_ENABLE_PREDICT=true
// (p.ej. en .env.local para probar en localhost). Gatea el chip del
// SourceSelector y el fetch de posiciones predict en useUnifiedPositions.
export const ENABLE_PREDICT = process.env.NEXT_PUBLIC_ENABLE_PREDICT === 'true';
// Hyperliquid is opt-in until HIP-4 has enough live mainnet markets to feature
// in production. Set NEXT_PUBLIC_ENABLE_HYPERLIQUID=true on staging/dev.
// Production keeps the source selector + landing-page CTAs hidden until ops
// flips this on.
export const ENABLE_HYPERLIQUID = process.env.NEXT_PUBLIC_ENABLE_HYPERLIQUID === 'true';
